import React, {useState} from "react"
import SyntaxHighlighter from 'react-syntax-highlighter';

const Code = ({id,code,type,title,collapsed}) => {
  let collapsible = collapsed ? true : false;
  let [open,setOpen] = useState(!collapsible)
  let titleDiv = title ? <div onClick={()=>collapsible && setOpen(!open)} className="code-title">
    {title} {collapsible ? (open ? "↑" : "↓") : null}
  </div> : null;
  return <div id={id ? id : ""} className={`code-box ${collapsible? "collapsible":""}`}>
    {titleDiv}
    {open ? <SyntaxHighlighter wrapLongLines={true} showLineNumbers="true" language={type} >
      {code}
    </SyntaxHighlighter> : null}
  </div>
}
export default Code
